module.exports = __webpack_public_path__ + "media/packs/images/flags/AF-3783774e6c03c3a86a357b0e4f1d78dc.svg";